import { UserEffects } from './user.effects';

export const AppEffects = [UserEffects];
